import React from "react";
import { useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import "./postBookingPages.css";

function PaymentErrorPage() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.entries().next().value;
  const { t } = useTranslation();

  return (
    <div className="main-container">
      <div className="payment-error-container">
        <span className="payment-error-span">
          {t("paymentErrorPage.bookingNumber")}: <b>{bookingId}</b>
        </span>
        <h1>{t("paymentErrorPage.title")}</h1>
        <span>{t("paymentErrorPage.message")}</span>
      </div>
    </div>
  );
}

export default PaymentErrorPage;